/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Direct_Message_LabelInputs */

const en_direct_message_label = /** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct Message`)
};

const es_direct_message_label = /** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje Directo`)
};

const fr_direct_message_label = /** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message direct`)
};

const de_direct_message_label = /** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktnachricht`)
};

const id_direct_message_label = /** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Langsung`)
};

/** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */
const ja_direct_message_label = en_direct_message_label;

/** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */
const zh_direct_message_label = en_direct_message_label;

/** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */
const ar_direct_message_label = en_direct_message_label;

/** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */
const it_direct_message_label = en_direct_message_label;

/** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */
const ru_direct_message_label = en_direct_message_label;

/** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */
const pt_direct_message_label = en_direct_message_label;

/** @type {(inputs: Direct_Message_LabelInputs) => LocalizedString} */
const ko_direct_message_label = en_direct_message_label;

/**
* | output |
* | --- |
* | "Direct Message" |
*
* @param {Direct_Message_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const direct_message_label = /** @type {((inputs?: Direct_Message_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Direct_Message_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_direct_message_label(inputs)
	if (locale === "es") return es_direct_message_label(inputs)
	if (locale === "fr") return fr_direct_message_label(inputs)
	if (locale === "de") return de_direct_message_label(inputs)
	if (locale === "ja") return ja_direct_message_label(inputs)
	if (locale === "zh") return zh_direct_message_label(inputs)
	if (locale === "ar") return ar_direct_message_label(inputs)
	if (locale === "id") return id_direct_message_label(inputs)
	if (locale === "it") return it_direct_message_label(inputs)
	if (locale === "ru") return ru_direct_message_label(inputs)
	if (locale === "pt") return pt_direct_message_label(inputs)
	return ko_direct_message_label(inputs)
});